import { useContext, useEffect, useState } from 'react';
import { CreateBookingFormContext, formActions } from '../CreateBookingForm.context';

const useGuestDetailsHook = () => {
  const { formState, dispatch } = useContext(CreateBookingFormContext);
  const [state, setState] = useState({
    initialized: false,
    isValid: false,
    formData: null,
  });

  useEffect(() => {
    if (formState) {
      const { guestsDetails } = formState;
      if (Boolean(guestsDetails)) {
        actions.initializeValidState(guestsDetails);
      }
      updateState({ initialized: true });
    }
  }, [formState]);

  const actions = {
    initializeValidState: data => {
      updateState({ isValid: true, formData: data });
    },
    onFormChange: params => {
      const { isValid, ...formData } = params;
      updateState({ isValid, formData });
    },
    saveGuestDetails: () => {
      dispatch({ type: formActions.SET_GUEST_DETAILS, payload: state.formData });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useGuestDetailsHook;
